import Vue from 'vue'

Vue.component('breadcrumb', () => import('./components/breadcrumb'));

